import api from '../common/api/shareUrlApi';

const basePath = '/share-urls';

export default {
  getList(params = { distribution: '' }) {
    return api.get(basePath, { params });
  },
  create(shareUrl) {
    return api.post(`${basePath}`, shareUrl);
  },
  get(shareUrlId, params = {}) {
    return api.get(`${basePath}/${shareUrlId}`, { params });
  },
  update(shareUrlId, shareUrl) {
    return api.put(`${basePath}/${shareUrlId}`, shareUrl);
  },
  delete(shareUrlId) {
    return api.delete(`${basePath}/${shareUrlId}`);
  }
};



// WEBPACK FOOTER //
// ./src/services/shareUrlService.js